import {
  AppBar,
  Avatar,
  Button,
  Divider,
  Link,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import { b2cPolicies } from 'B2C';
import { mokedNumber } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import {
  Call,
  FooterBackgroundVectors,
  FooterCall,
  FooterContact,
  FooterVectors,
  Logo2,
  MOD,
  Message,
  MobileContact,
  YourTeam,
} from 'Images';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

export const Footer2 = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Footer);
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();

  const onUpdatePassword = () => {
    const xToken = sessionStorage.getItem('B2CToken');
    if (xToken && inProgress === InteractionStatus.None) {
      instance.loginRedirect({
        ...b2cPolicies.authorities.editProfile,
        extraQueryParameters: {
          xToken,
        },
      });
    }
  };

  return isDesktop ? (
    <AppBar
      component={'footer'}
      sx={{
        position: 'relative',
        padding: '56px 0px 26px 0px',
        paddingLeft: { sm: '10%', xl: '250px' },
        zIndex: 1100,
      }}
    >
      <Stack>
        <Stack maxWidth={1000} gap={'56px'}>
          <Stack gap={'48px'}>
            <Stack direction={'row'} gap={'100px'}>
              <Stack
                direction={'row'}
                width={'auto'}
                gap={'20px'}
                padding={0}
                margin={0}
                alignItems={'center'}
                height={'min-content'}
                mr={'74px'}
                onClick={() => {
                  window.location.href =
                    process.env.REACT_APP_MARKETING_SITE_URL || '';
                }}
                sx={{ cursor: 'pointer' }}
              >
                <Avatar
                  alt={''}
                  src={Logo2}
                  sx={{ height: '62px', width: '57px' }}
                />
                <Typography
                  whiteSpace={'nowrap'}
                  variant={'body1'}
                  component={'h3'}
                  tabIndex={0}
                >
                  {dictionary.shikum}
                </Typography>
              </Stack>
              {Object.values(dictionary.links).map((link, index1) => (
                <Stack
                  key={index1}
                  component={'ul'}
                  width={'auto'}
                  gap={'12px'}
                  padding={0}
                  margin={0}
                >
                  <Typography
                    variant={'body1'}
                    color={'#fff'}
                    tabIndex={0}
                    component={'li'}
                  >
                    {link.title}
                  </Typography>
                  {link.redirects.map((redirect, index2) => (
                    <ListItem
                      key={index2}
                      sx={{ padding: 0, marginBottom: '16px' }}
                    >
                      <Link
                        onClick={
                          (redirect as any).isUpdatePassword
                            ? onUpdatePassword
                            : undefined
                        }
                        href={redirect.href}
                        underline={'none'}
                      >
                        <Typography variant={'body6'} color={'#fff'}>
                          {redirect.label}
                        </Typography>
                      </Link>
                    </ListItem>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Stack>
          <Divider
            orientation='horizontal'
            aria-hidden={'true'}
            sx={{ borderColor: 'primary.shade_50' }}
          />
          <Stack direction={'row'} gap={'20px'} height={'56px'}>
            <Button
              variant={'primary'}
              role={'link'}
              href={`tel:${mokedNumber}`}
              sx={{
                width: '120px',
                height: '100%',
                padding: '12px',
                gap: '12px',
              }}
            >
              <Avatar
                alt={''}
                src={Call}
                sx={{ width: '20px', height: '24px' }}
              />
              <Typography variant={'body2'}>{dictionary.callButton}</Typography>
            </Button>
            <Button
              variant={'purple'}
              sx={{
                width: '160px',
                height: '100%',
                padding: '12px',
                gap: '12px',
              }}
              onClick={() => {
                navigate('/personal-team?Contact=1');
              }}
            >
              <Avatar src={Message} sx={{ width: '20px', height: '20px' }} />
              <Typography variant={'body2'}>
                {dictionary.contactButton}
              </Typography>
            </Button>
            <Button
              variant={'secondary'}
              sx={{
                width: '160px',
                height: '100%',
                padding: '12px',
                gap: '12px',
                '&:hover': {
                  bgcolor: '#fff',
                },
                cursor: 'pointer',
              }}
              onClick={() => navigate('/personal-team')}
            >
              <Avatar src={YourTeam} sx={{ width: '20px', height: '20px' }} />
              <Typography color={'primary'} variant={'body2'}>
                {dictionary.yourTeam}
              </Typography>
            </Button>
          </Stack>
        </Stack>
        <Stack
          direction={'row'}
          justifyContent={'center'}
          marginTop={'24px'}
          gap={'20px'}
          tabIndex={0}
        >
          <Typography variant={'body6'}>{dictionary.rightsSymbol}</Typography>
          <Typography variant={'body6'}>{dictionary.rights}</Typography>
        </Stack>
      </Stack>
      <Avatar
        src={FooterVectors}
        alt={''}
        sx={{
          visibility: { xs: 'hidden', lg: 'visible' },
          position: 'absolute',
          width: 'auto',
          height: 'auto',
          bottom: '0',
          right: '0',
        }}
      />
    </AppBar>
  ) : (
    <AppBar
      component={'footer'}
      sx={{
        position: 'relative',
        zIndex: 1100,
      }}
    >
      <Stack gap={'32px'} padding={'32px 24px'}>
        <Stack direction={'row'} gap={'24px'}>
          <Stack
            width={'auto'}
            alignItems={'center'}
            onClick={() => navigate('/')}
          >
            <Avatar
              src={Logo2}
              alt={''}
              sx={{ height: '62px', width: '57px' }}
            />
            <Typography variant={'body1'} component={'h2'} tabIndex={0}>
              {dictionary.shikum}
            </Typography>
          </Stack>
          <Stack width={'auto'} alignItems={'center'}>
            <Avatar alt={''} src={MOD} sx={{ height: '62px', width: '57px' }} />
            <Typography variant={'body1'} component={'h2'} tabIndex={0}>
              {dictionary.ministryOfDefense}
            </Typography>
          </Stack>
        </Stack>
        <Stack gap={'32px'} flexWrap={'wrap'} direction={'row'}>
          {Object.values(dictionary.links).map((link, index1) => (
            <Stack
              component={'ul'}
              width={'auto'}
              gap={'12px'}
              padding={0}
              margin={0}
              key={index1}
            >
              <Typography
                variant={'body1'}
                color={'#fff'}
                tabIndex={0}
                component={'h5'}
              >
                {link.title}
              </Typography>
              {link.redirects.map((redirect, index2) => (
                <ListItem key={index2} sx={{ padding: 0 }}>
                  <Link
                    onClick={
                      (redirect as any).isUpdatePassword
                        ? onUpdatePassword
                        : undefined
                    }
                    href={redirect.href}
                    underline={'none'}
                  >
                    <Typography variant={'body6'} color={'#fff'}>
                      {redirect.label}
                    </Typography>
                  </Link>
                </ListItem>
              ))}
            </Stack>
          ))}
        </Stack>
        <Divider
          orientation='horizontal'
          sx={{ borderColor: 'primary.shade_500' }}
        />
        <Stack direction={'row'} gap={'20px'} height={'36px'}>
          <Button
            variant={'primary'}
            role={'link'}
            href={`tel:${mokedNumber}`}
            sx={{
              width: '85px',
              height: '100%',
              padding: '8px 10px',
              gap: '6px',
            }}
          >
            <Avatar
              alt={''}
              src={FooterCall}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant={'body5'}>{dictionary.callButton}</Typography>
          </Button>
          <Button
            variant={'purple'}
            sx={{
              width: '111px',
              height: '100%',
              padding: '8px 10px',
              gap: '6px',
            }}
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_MARKETING_SITE_URL}ContactUs`;
            }}
          >
            <Avatar
              alt={''}
              src={FooterContact}
              sx={{ width: '20px', height: '18px' }}
            />
            <Typography variant={'body5'} whiteSpace={'nowrap'}>
              {dictionary.contactButton}
            </Typography>
          </Button>
          <Button
            sx={{ padding: '0', minWidth: '0' }}
            tabIndex={0}
            onClick={() => navigate('/personal-team')}
          >
            <Avatar
              alt={''}
              src={MobileContact}
              sx={{ width: '110px', height: '30px' }}
            />
          </Button>
        </Stack>
        <Stack
          direction={'row'}
          justifyContent={'center'}
          gap={'5px'}
          tabIndex={0}
        >
          <Typography variant={'body6'}>{dictionary.rightsSymbol}</Typography>
          <Typography variant={'body6'}>{dictionary.rights}</Typography>
        </Stack>
      </Stack>
      <Avatar
        alt={''}
        src={FooterBackgroundVectors}
        sx={{
          position: 'absolute',
          width: 'auto',
          height: 'auto',
          top: '0',
          right: '0',
        }}
      />
    </AppBar>
  );
};
